import * as qs from 'query-string';
import * as React from 'react';
import ReactJson from 'react-json-view';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { me, showResult } from '../actions/demo';
import DemoApiResponse from '../components/demo-api-response';
import { withDefaultStyles } from '../utils/material-ui/hoc';

class TokenDemo extends React.Component<any, any> {
    public render() {
        const tokens: any = {
            ...qs.parse(this.props.location.hash)
        }
        return (
            <div>
                <Typography variant='h4'>The Token Issued by Flybits IdP</Typography>
                <ReactJson collapseStringsAfterLength={30} displayDataTypes={false} displayObjectSize={false} src={tokens} />
                <Button onClick={this.doTestMe(tokens.access_token)} color="primary">Test Token</Button>
                <DemoApiResponse handleClose={this.doCloseResultDialog} />
            </div>
        );
    }
    private doTestMe = (token: string) => () => this.props.dispatch(me(token));
    private doCloseResultDialog = () => this.props.dispatch(showResult(false));
}
const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(withRouter(connect(
    mapStateToProps,
)(TokenDemo)));



// WEBPACK FOOTER //
// ./src/containers/token-demo.tsx